import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
import BrandLayout from '../components/brand/BrandLayout';
import BrandHero from '../components/brand/BrandHero';
import CompanyIntelligence from '../components/brand/CompanyIntelligence';
import ProjectHistory from '../components/brand/ProjectHistory';
import { useBrandLanguage } from '../components/brand/BrandLanguage';
import '../styles/experience.css';
import '../styles/identity.css';
import '../styles/motion.css';
import '../styles/company.css';
import '../styles/link01.css';

export default function Home() {
  const { language, t } = useBrandLanguage();
  const ko = language === 'ko';
  return <BrandLayout><div className="cx-home cb-home">
    <BrandHero />
    <section className="cb-jev cx-wrap" aria-labelledby="jev-direction">
      <Link className="cb-jev-link" to="/models">
        <div className="cb-jev-word" aria-hidden="true">C1<span>↗</span></div>
        <div className="cb-jev-copy"><p className="cb-overline">CONNECT AI V3 <span>{ko ? '첫 가중치 공개' : 'FIRST WEIGHTS RELEASED'}</span></p><h2 id="jev-direction">{ko ? <>기업 의사결정<br />모델.</> : <>Company decision<br />model.</>}</h2><p>{ko ? '0.8B · 공개 가중치 · 실제 실험 기록' : '0.8B · open weights · recorded experiments'}</p></div>
        <ArrowUpRight className="cb-jev-arrow" size={32} />
      </Link>
    </section>
    <section className="link01-home cx-wrap" aria-label="Connect AI V4 · LINK-01"><Link to="/robots/link-01"><img src="/research/link-01-concept-v1.png" alt={ko ? 'LINK-01 초기 AI 생성 콘셉트 · 최종 디자인 아님' : 'LINK-01 early AI-generated concept · not final design'} loading="lazy"/><div><p className="link01-eyebrow">V3 → V4 / PHYSICAL AI</p><h2>LINK-01</h2><p>{ko ? 'R0 설계 · MuJoCo · CPU PPO 실험 · 실물 검증 전' : 'R0 design · MuJoCo · CPU PPO experiments · hardware unverified'}</p></div><ArrowUpRight size={28}/></Link></section>
    <CompanyIntelligence />
    <ProjectHistory />
    <section className="cx-frontiers cx-wrap">
      <div className="cx-section-kicker"><span>{t('03 / THE NEXT FRONTIERS')}</span><span>{t('RESEARCH DIRECTIONS')}</span></div>
      <div className="cx-frontier-heading"><h2>Physical AI × AI-native company</h2></div>
      <div className="cx-frontier-links">
        <Link to="/research#physical"><span className="cx-frontier-num">01</span><div><span>{t('PHYSICAL AI')}</span><h3>{ko ? '관찰 · 판단 · 행동' : 'Observe · decide · act'}</h3><p>{t('Exploring decisions in environments that move.')}</p></div><div className="cb-physical-art" aria-hidden="true"><i /><i /><i /><b /></div><ArrowUpRight size={28} /></Link>
        <Link to="/models"><span className="cx-frontier-num">02</span><div><span>AI-NATIVE COMPANY</span><h3>{ko ? '제품 · 고객 · 운영' : 'Product · customers · operations'}</h3><p>{ko ? '제품 · 고객 · 운영의 판단을 실행 에이전트와 연결합니다.' : 'Connecting product, customer, and operational decisions to execution agents.'}</p></div><div className="cx-business-symbol" aria-hidden="true"><span>YOU</span><i /><b>+</b><i /><span>AI</span></div><ArrowUpRight size={28} /></Link>
      </div>
    </section>
    <section className="cb-purpose">
      <div className="cx-wrap">
        <div className="cx-section-kicker"><span>THE REASON WE BUILD</span><span>OWN. RUN. CONNECT.</span></div>
        <h2>Own. Run.<br /><span>Connect.</span></h2>
        <div className="cb-purpose-bottom"><p>{ko ? '우리의 AI를 소유하고, 실행하고, 연결합니다.' : 'Building AI we can own, run, and connect—on our own terms.'}</p><Link to="/about">{ko ? '우리가 만드는 이유' : 'Why we build'}<ArrowUpRight size={20} /></Link></div>
        <div className="cb-purpose-signature" aria-hidden="true">CONNECT<span>AI</span><i>↗</i></div>
      </div>
    </section>
    <div className="cx-legacy cx-wrap"><span>EZERAI WORKSPACE</span><p>{t('Already using EZERAI?')}</p><Link to="/tools">{t('All your tools, still here')}<ArrowRight size={18} /></Link></div>
  </div></BrandLayout>;
}
